<template>
    <tis-button
        :class="{'tablet:flex-row-reverse':evenListItem && !relatedPosts, 'tablet:flex-row': !relatedPosts, 'phone:mx-0 mx-2 first:ml-0 last:mr-0 w-full': relatedPosts}"
        :full-redirect="true"
        :url="getBlogPostProperty('postMeta', 'url')"
        class="article-list-item flex flex-col">
        <div
            :class="{'tablet:max-w-1/2': !relatedPosts}"
            class="article-featured-image w-full">
            <responsive-image
                :alt="getBlogPostProperty('featuredImage', 'alt')"
                :fallback-image="getBlogPostProperty('featuredImage', 'src')"
                :image="{ srcset:getBlogPostProperty('featuredImage', 'srcSet'), url:getBlogPostProperty('featuredImage', 'src') }"
                class="w-full h-full object-cover"
            />
        </div>
        <div
            :class="{'tablet:p-10 tablet:max-w-1/2': !relatedPosts }"
            class="post-data flex flex-col justify-center py-4 mt-6">
            <post-meta
                v-if="!relatedPosts"
                :post-category="getBlogPostPropertyGroup('postCategory')"
                :post-meta="getBlogPostPropertyGroup('postMeta')"
                class="mb-10 mt-4"
                in-list-item="true"
            />
            <h2
                class="text-2xl tablet:text-3xl uppercase tablet:-mt-3 font-bold tracking-tight leading-none text-white"
                v-text="getBlogPostProperty('postContent', 'title_1')" />
            <h3
                class="text-2xl tablet:text-3xl font-light text-white uppercase tracking-tight"
                v-text="getBlogPostProperty('postContent', 'title_2')" />
            <div
                class="text-lg text-white font-regular mb-6"
                v-html="getBlogPostProperty('postContent', 'excerpt')" />

            <!-- CTA button -->
            <a class="btn-flat block text-sm tablet:max-w-xxs group transition-transform">
                {{ labels.btnReadPost }}
                <svg-icon
                    class="w-6 h-6 inline-block ml-2 transform transition-transform duration-200 group-hover:translate-x-1"
                    icon="arrow-horizontal" />
            </a>
        </div>
    </tis-button>
</template>

<script>
import PostMeta from '@web/components/Blog/PostMeta';
import ResponsiveImage from '@web/components/ResponsiveImage';
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { get } from 'lodash';

export default {
  name: 'ListPostItem',
  components: {
    PostMeta, ResponsiveImage, TisButton, SvgIcon,
  },
  props: {
    labels: {
      type: Object,
      required: true,
    },
    blogPost: {
      type: Object,
      required: true,
    },
    evenListItem: {
      type: Boolean,
      required: false,
    },
    relatedPosts: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getBlogPostProperty(group, property) {
      return get(this, ['blogPost', group, property]);
    },
    getBlogPostPropertyGroup(group) {
      return get(this, ['blogPost', group]);
    },
  },
};
</script>
<style>
    .article-list-item {
        min-height: 400px;
    }
</style>
